var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.84332 11.1867C7.67265 11.1867 6.72363 10.2119 6.72363 9.00935C6.72363 7.80685 7.67265 6.83203 8.84332 6.83203C10.014 6.83203 10.963 7.80685 10.963 9.00935C10.963 10.2119 10.014 11.1867 8.84332 11.1867ZM14.143 3.5659C14.8716 3.5659 15.4678 4.17827 15.4678 4.92673V13.0917C15.4678 13.8401 14.8716 14.4525 14.143 14.4525H3.54453C2.81589 14.4525 2.21973 13.8401 2.21973 13.0917V4.92673C2.21973 4.17827 2.81589 3.5659 3.54453 3.5659H5.64435L6.45911 2.64735C6.71082 2.36838 7.06852 2.20508 7.43946 2.20508H10.2481C10.619 2.20508 10.9767 2.36838 11.2218 2.64735L12.0432 3.5659H14.143ZM8.84424 12.4115C10.6725 12.4115 12.1563 10.8874 12.1563 9.00948C12.1563 7.13155 10.6725 5.60742 8.84424 5.60742C7.01601 5.60742 5.53223 7.13155 5.53223 9.00948C5.53223 10.8874 7.01601 12.4115 8.84424 12.4115Z",
    fill: "#77939C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/camera-icon.54309dcbc8fd46788367061a7e40d4eb.svg";
export { ForwardRef as ReactComponent };